module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('ProductTabs'), _vm._v(" "), _c('form', {
    attrs: {
      "id": "formRent"
    },
    on: {
      "submit": _vm.checkForm
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.title) ? _c('div', {
    staticClass: "card-header-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.title) + "\n                        "), _vm._m(0)]) : _vm._e()])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "logout-message",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loading')) + "\n                                "), _c('i', {
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]) : _vm._l((_vm.rows), function(row) {
    return _c('div', {
      staticClass: "statistic-wrap"
    }, [(_vm.loading) ? _c('div', {
      staticClass: "card-block"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "logout-message",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.$t('message.loading')) + "\n                                "), _c('i', {
      staticClass: "fa fa-spinner fa-spin",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card statistic-table statistic-table-balance"
    }, [(_vm.title) ? _c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n                        " + _vm._s(row.country) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-block card-zz"
    }, [_c('table', {
      staticClass: "table",
      attrs: {
        "id": row.id
      }
    }, [_c('thead', [_c('tr', _vm._l((_vm.computedHeadColumns), function(col) {
      return _c('th', {
        style: (_vm.renderBackground(false, col.field, false)),
        attrs: {
          "colspan": col.colspan,
          "width": col.width ? col.width : 'auto'
        }
      }, [_vm._v(_vm._s(col.label))])
    }))]), _vm._v(" "), _c('tbody', [_vm._l((row.goods), function(cell) {
      return (cell.hidden === 0) ? _c('tr', [_c('td', [_c('input', {
        staticClass: "input-check",
        attrs: {
          "id": 'check' + cell.alias + '-' + cell.country_id,
          "ishidden": cell.hidden,
          "type": "checkbox"
        }
      })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cell.name.value))]), _vm._v(" "), (cell.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(cell.price.update, cell.remnants.value, $event.target.value, cell.alias, cell.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-remnants",
        attrs: {
          "id": 'g' + cell.alias,
          "type": "text"
        },
        domProps: {
          "value": cell.remnants.value
        }
      })]) : (!cell.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(cell.price.update, cell.remnants.value, $event.target.value, cell.alias, cell.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-remnants",
        attrs: {
          "id": 'g' + cell.alias,
          "type": "text",
          "value": "-"
        }
      })]) : _vm._e(), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#b9f6ca"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(cell.price.update, cell.price.value, $event.target.value, cell.alias, cell.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-price",
        attrs: {
          "id": 'g' + cell.alias,
          "name": 'c' + cell.country_id,
          "type": "text"
        },
        domProps: {
          "value": cell.price.value
        }
      })]), _vm._v(" "), (cell.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#c8cce6"
        }
      }, [_vm._v(_vm._s(cell.priceAll.value.toFixed(2)))]) : (!cell.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#c8cce6"
        }
      }, [_vm._v(" - ")]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _c('tr', {
      on: {
        "click": function($event) {
          _vm.isCheckBox($event, row.id)
        }
      }
    }, [_c('td'), _vm._v(" "), (_vm.isActive === false) ? _c('td', [_c('span', {
      staticClass: "badge badge-success badge-hidden",
      staticStyle: {
        "color": "#263238"
      }
    }, [_vm._v("Скрытые офферы"), _c('i', {
      staticClass: "fa fa-arrow-down",
      staticStyle: {
        "margin": "0 5px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isActive === true) ? _c('td', [_c('span', {
      staticClass: "badge badge-success badge-hidden",
      staticStyle: {
        "color": "#263238"
      }
    }, [_vm._v("Скрытые офферы"), _c('i', {
      staticClass: "fa fa-arrow-up",
      staticStyle: {
        "margin": "0 5px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((row.goods), function(ce) {
      return (_vm.isActive && ce.hidden === 1) ? _c('tr', [_c('td', [_c('input', {
        staticClass: "input-check",
        attrs: {
          "id": 'check' + ce.alias + '-' + ce.country_id,
          "ishidden": ce.hidden,
          "type": "checkbox"
        }
      })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ce.name.value))]), _vm._v(" "), (ce.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(ce.price.update, ce.remnants.value, $event.target.value, ce.alias, ce.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-remnants",
        attrs: {
          "id": 'g' + ce.alias,
          "type": "text"
        },
        domProps: {
          "value": ce.remnants.value
        }
      })]) : (!ce.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(ce.price.update, ce.remnants.value, $event.target.value, ce.alias, ce.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-remnants",
        attrs: {
          "id": 'g' + ce.alias,
          "type": "text",
          "value": "-"
        }
      })]) : _vm._e(), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#b9f6ca"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(ce.price.update, ce.price.value, $event.target.value, ce.alias, ce.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-price",
        attrs: {
          "id": 'g' + ce.alias,
          "name": 'c' + ce.country_id,
          "type": "text"
        },
        domProps: {
          "value": ce.price.value
        }
      })]), _vm._v(" "), (ce.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#c8cce6"
        }
      }, [_vm._v(_vm._s(ce.priceAll.value.toFixed(2)))]) : (!ce.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#c8cce6"
        }
      }, [_vm._v(" - ")]) : _vm._e()]) : _vm._e()
    })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', [_vm._v("Итого:")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#fff9c4"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.footColumns[row.id].totalRemnants.value))])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#b9f6ca"
      }
    }), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#c8cce6"
      }
    }, [_c('span', [_vm._v("$ " + _vm._s((_vm.footColumns[row.id].totalPrice.value).toFixed(2)))])])])])], 1)])])])
  })], 2)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success btn-lg btn-check",
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("\n                            Сохранить\n                        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69c45af9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/product/ProductBalance.vue
// module id = 571
// module chunks = 0